import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { OVERLAY_DATA } from 'src/app/shared/services/dynamic-overlay/dynamic-overlay.service';

@Component({
  selector: 'app-template-list',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatListModule, MatButtonModule, MatIconModule, TranslateModule, MatTooltipModule],
  template: `
    <div class="template-list-container" [style.width.px]="data.width || 320">
      <header>
        <mat-form-field appearance="fill">
          <input #searchInput matInput [(ngModel)]="searchTerm" (ngModelChange)="filterTemplates()" [placeholder]="'Global.Search' | translate" />
        </mat-form-field>
        <button mat-icon-button (click)="edit.emit()" [matTooltip]="'Templates.EditButton' | translate">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="create.emit()" [matTooltip]="'Templates.CreateButton' | translate">
          <mat-icon>add</mat-icon>
        </button>
      </header>
      <mat-nav-list>
        @for (template of filteredTemplates; track template) {
          <a mat-list-item (click)="selectTemplate(template._id)" [class.selected]="template._id === data.selectedId">
            {{ template.name }}
          </a>
        }
      </mat-nav-list>
    </div>
  `,
  styleUrls: ['./template-list.component.scss'],
})
export class TemplateListComponent implements AfterViewInit {
  @Output() templateSelected = new EventEmitter<string>();
  @Output() edit = new EventEmitter<void>();
  @Output() create = new EventEmitter<void>();

  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  data: { templates: any[]; selectedId: string; width?: number } = inject(OVERLAY_DATA);

  allTemplates = this.data.templates;
  filteredTemplates = [...this.allTemplates];
  searchTerm = '';

  constructor() {
    this.filterTemplates();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInput.nativeElement.focus(), 0);
  }

  filterTemplates(): void {
    if (!this.searchTerm) {
      this.filteredTemplates = [...this.allTemplates];
    } else {
      this.filteredTemplates = this.allTemplates.filter((template) => template.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
    }
  }

  selectTemplate(id: string): void {
    this.templateSelected.emit(id);
  }
}
